import { render, staticRenderFns } from "./select-dict-checkbox.vue?vue&type=template&id=fc7c8bec&scoped=true"
import script from "./select-dict-checkbox.vue?vue&type=script&lang=js"
export * from "./select-dict-checkbox.vue?vue&type=script&lang=js"
import style0 from "./select-dict-checkbox.vue?vue&type=style&index=0&id=fc7c8bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7c8bec",
  null
  
)

export default component.exports